import { UnorderedList, HStack, Text, Stack, Icon } from '@chakra-ui/react'
import { useTrail } from 'react-spring'
import { useInView } from 'react-intersection-observer'

import { AnimatedListItem, DEFAULT_SPRING_CONFIG } from '@/lib/springComponent'

import { ReactComponent as CheckIcon } from '@/svg/services/check.svg'

interface Props {
  items: React.ReactNode[]
}

function CheckList({ items }: Props): React.ReactElement {
  const { ref, inView } = useInView({
    threshold: 0.3,
    triggerOnce: true,
  })

  const trails = useTrail(items.length, {
    opacity: inView ? 1 : 0,
    transform: inView ? 'translate3d(0, 0px, 0)' : 'translate3d(0, 16px, 0)',
    config: DEFAULT_SPRING_CONFIG,
  })

  return (
    <Stack
      as={UnorderedList}
      sx={{
        listStyleType: 'none',
        listStylePosition: 'inside',
        fontSize: { base: 'md', sm: 'lg' },
        ml: 0,
      }}
      ref={ref}
      spacing={{
        base: 4,
        sm: 6,
      }}
    >
      {items.map((item, index) => {
        const style = trails[index]

        return (
          <AnimatedListItem
            key={index}
            style={style}
            sx={{
              bg: 'gray.50',
              px: { base: 7, md: 9 },
              py: { base: 4, md: 8 },
              borderRadius: '2xl',
            }}
          >
            <HStack
              spacing={{ base: 4, md: 6 }}
              sx={{
                alignItems: 'center',
              }}
            >
              <Icon as={CheckIcon} sx={{ boxSize: { base: 10, md: 15 } }} />
              <Text sx={{ fontSize: { base: 'lg', md: '2xl' } }}>{item}</Text>
            </HStack>
          </AnimatedListItem>
        )
      })}
    </Stack>
  )
}

export default CheckList
